import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d01fe95c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "x-photoswipe/dist/photoswipe.css?vue&type=style&index=0&lang=css&"
import style1 from "x-photoswipe/dist/default-skin/default-skin.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports